import axios from 'axios';

/**
 * Materieel (resources): vans, equipment, tools and the requirements that
 * link them to work orders.
 */
export const resourceService = {
  async getAll(params = {}) {
    const response = await axios.get('/resources', { params });
    return response.data.resources || [];
  },

  async getById(id) {
    const response = await axios.get(`/resources/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await axios.post('/resources', data);
    return response.data;
  },

  async update(id, data) {
    const response = await axios.patch(`/resources/${id}`, data);
    return response.data;
  },

  async delete(id) {
    await axios.delete(`/resources/${id}`);
  },

  async getCategories() {
    const response = await axios.get('/resources/categories');
    return response.data.categories || [];
  },

  /** { conflicts, by_work_order } for a date range (YYYY-MM-DD). */
  async getConflicts(from, to) {
    const response = await axios.get('/resources/conflicts', { params: { from, to } });
    return response.data;
  },

  /** { from, to, resources, requirements, unavailability, conflicts } */
  async getTimeline(from, to) {
    const response = await axios.get('/resources/timeline', { params: { from, to } });
    return response.data;
  },

  async getRentals() {
    const response = await axios.get('/resources/rentals');
    return response.data.rentals || [];
  },

  async checkAvailability(payload) {
    const response = await axios.post('/resources/check-availability', payload);
    return response.data;
  },

  // Work order requirements
  async getWorkOrderRequirements(workOrderId) {
    const response = await axios.get(`/work-orders/${workOrderId}/resources`);
    return response.data.requirements || [];
  },

  async addWorkOrderRequirement(workOrderId, data) {
    const response = await axios.post(`/work-orders/${workOrderId}/resources`, data);
    return response.data;
  },

  async deriveWorkOrderRequirements(workOrderId) {
    const response = await axios.post(`/work-orders/${workOrderId}/resources/derive`);
    return response.data;
  },

  async updateWorkOrderRequirement(workOrderId, requirementId, data) {
    const response = await axios.patch(
      `/work-orders/${workOrderId}/resources/${requirementId}`,
      data
    );
    return response.data;
  },

  async deleteWorkOrderRequirement(workOrderId, requirementId) {
    await axios.delete(`/work-orders/${workOrderId}/resources/${requirementId}`);
  },

  async getProjectSummary(projectId) {
    const response = await axios.get(`/projects/${projectId}/resources`);
    return response.data;
  },
};
